// Парсер URL → тип страницы

/**
 * Парсит URL путь и определяет тип страницы
 * @param {string} path - путь URL
 * @returns {object} - объект с типом страницы и параметрами
 */
export function parseRoute(path) {
  // Нормализуем путь: убираем начальный и конечный слеш
  const normalizedPath = path.replace(/^\/+|\/+$/g, '');

  // Главная «/» — это лендинг.
  if (normalizedPath === '' || normalizedPath === '/') {
    return { type: 'landing' };
  }

  // Приложение (форма создания сказки).
  if (normalizedPath === 'app') {
    return { type: 'app' };
  }

  // Мои заказы (только сказки).
  if (normalizedPath === 'orders') {
    return { type: 'orders' };
  }

  // /skazki ведёт в приложение (back-compat со старыми ссылками).
  if (normalizedPath === 'skazki') {
    return { type: 'app' };
  }

  // Открыть конкретную сказку по ссылке (back-compat).
  if (normalizedPath.startsWith('skazki/s/')) {
    const taleId = normalizedPath.replace('skazki/s/', '').replace(/\/+$/, '');
    if (taleId) return { type: 'skazkiTale', taleId };
    return { type: 'app' };
  }

  // Создать новую сказку (back-compat).
  if (normalizedPath === 'skazki/new') {
    return { type: 'skazkiNew' };
  }

  return { type: 'notFound' };
}
